import React, { useState, useEffect } from "react";
import {NON_HERO_BACKGROUND} from "../../constants/styles";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import DashboardSelector from "../DashboardSelector";
import FilterPanel from "../FilterPanel";

export default function UtilityDashboardLayout({
  title,
  childDashboards,
  refreshFunction,
  children
}) {

  const thisContainer = {
    display: "flex",
    position: "fixed",
    flexDirection: "column",
    width: "100%",
    left: "0px",
    top: "0px",
	bottom:'0px'
  };

  const mainContainer = {
    display: "flex",
    position: "fixed",
    top: "0px",
    left: "60px",
    bottom: "0px",
    right: "0px",
    flexDirection: "column",
    overflowY: "auto",
	overflowX: "hidden",
    background: "rgba(255, 255, 255, 0.55)",
	paddingTop:'60px'
  };
  
  const contentWrapper = {
    display: "flex",
    width: "100%",
    padding: "20px",
    boxSizing: "border-box",
    gap: "20px",          // horizontal spacing
    alignItems: "stretch", // ensures equal height,
	flexGrow:1
  };
  

  return (
    <div style={thisContainer}>
      <Header transitionHide={true} showSurveySelector = {true}/>
      <LeftMenu />

      <DashboardSelector
        title={title}
        childDashboards={childDashboards}
      />

      <div style={mainContainer}>
        <FilterPanel refreshFunction={refreshFunction} />

		<div style={contentWrapper}>
		   	 {children}
		  </div>
      </div>
    </div>
  );
}
